import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [isPhonePopupOpen, setIsPhonePopupOpen] = useState(false);

  const handleNavigation = (path: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
    }
  };

  return (
    <>
      {/* モバイル固定CTA */}
      <div className="fixed bottom-0 left-0 right-0 bg-[#FFC107] p-2 sm:p-3 md:p-4 flex items-center justify-between xl:hidden z-50">
        <div className="flex-1 min-w-0 mr-2">
          <span className="text-black font-bold text-xs sm:text-sm md:text-base">無料相談・お見積り</span>
        </div>
        <div className="flex items-center gap-1 sm:gap-2 md:gap-3">
          <button 
            onClick={() => setIsPhonePopupOpen(true)}
            className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-black text-white rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-800 transition-colors flex-shrink-0"
          >
            <i className="ri-phone-line text-sm sm:text-lg md:text-xl"></i>
          </button>
          <button className="px-2 py-1 sm:px-3 sm:py-2 md:px-4 md:py-3 bg-black text-white rounded-lg font-bold text-xs sm:text-sm md:text-base whitespace-nowrap cursor-pointer hover:bg-gray-800 transition-colors">
            お問い合わせ
          </button>
        </div>
      </div>

      {/* モバイル電話番号選択ポップアップ */}
      {isPhonePopupOpen && (
        <div className="xl:hidden fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-3 sm:p-4">
          <div className="bg-white rounded-2xl w-full max-w-sm shadow-xl">
            <div className="p-3 sm:p-4 md:p-6">
              <div className="flex items-center justify-between mb-3 sm:mb-4 md:mb-6">
                <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-900">お電話でのご相談</h3>
                <button
                  onClick={() => setIsPhonePopupOpen(false)}
                  className="flex items-center justify-center w-6 h-6 sm:w-8 sm:h-8 text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <i className="ri-close-line text-lg sm:text-xl"></i>
                </button>
              </div>

              <div className="text-center mb-3 sm:mb-4 md:mb-6">
                <p className="text-xs sm:text-sm md:text-base text-gray-600">受付時間: 平日9:00〜17:00</p>
              </div>

              <div className="space-y-2 sm:space-y-3 md:space-y-4">
                <a
                  href="tel:0952-71-9855"
                  className="block p-2 sm:p-3 md:p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors cursor-pointer"
                  onClick={() => setIsPhonePopupOpen(false)}
                >
                  <div className="text-center">
                    <div className="font-semibold text-gray-900 mb-1 text-xs sm:text-sm md:text-base">IDS佐賀教習所</div>
                    <div className="text-lg sm:text-xl md:text-2xl font-bold text-[#2A6041]">
                      <i className="ri-phone-line mr-1"></i>
                      0952-71-9855
                    </div>
                  </div>
                </a>

                <a
                  href="tel:0952-97-5291"
                  className="block p-2 sm:p-3 md:p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors cursor-pointer"
                  onClick={() => setIsPhonePopupOpen(false)}
                >
                  <div className="text-center">
                    <div className="font-semibold text-gray-900 mb-1 text-xs sm:text-sm md:text-base">IDS川副教習所</div>
                    <div className="text-lg sm:text-xl md:text-2xl font-bold text-[#2A6041]">
                      <i className="ri-phone-line mr-1"></i>
                      0952-97-5291
                    </div>
                  </div>
                </a>

                <a
                  href="tel:099-213-9466"
                  className="block p-2 sm:p-3 md:p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors cursor-pointer"
                  onClick={() => setIsPhonePopupOpen(false)}
                >
                  <div className="text-center">
                    <div className="font-semibold text-gray-900 mb-1 text-xs sm:text-sm md:text-base">IDS鹿児島教習所</div>
                    <div className="text-lg sm:text-xl md:text-2xl font-bold text-[#2A6041]">
                      <i className="ri-phone-line mr-1"></i>
                      099-213-9466
                    </div>
                  </div>
                </a>
              </div>

              <div className="mt-3 sm:mt-4 md:mt-6 text-center">
                <p className="text-xs sm:text-sm md:text-base text-gray-500 leading-relaxed">
                  無理な営業は一切いたしませんので、<br />
                  お気軽にご連絡ください。
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      <footer className="bg-[#2A6041] text-white lg:mb-0 mb-12 sm:mb-16 md:mb-20">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 py-8 sm:py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-10">
            {/* ロゴと拠点情報 */}
            <div className="md:col-span-2">
              <div className="mb-3 sm:mb-4 md:mb-6">
                <button 
                  onClick={() => handleNavigation('/')}
                  className="cursor-pointer"
                >
                  <img 
                    src="https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/2861c136ef6426e64f8243c52e776950.webp" 
                    alt="IDS教習所グループ" 
                    className="h-6 sm:h-8 md:h-10 w-auto"
                  />
                </button>
              </div>
              <div className="space-y-3 sm:space-y-4 md:space-y-6">
                <div>
                  <h4 className="font-bold text-[#76B947] mb-2 text-sm sm:text-base md:text-lg">IDS佐賀教習所（株式会社アイテム）</h4>
                  <p className="text-gray-300 text-xs sm:text-sm md:text-base leading-relaxed">
                    〒846-0002 佐賀県多久市北多久町大字小侍4771<br />
                    <i className="ri-phone-line mr-2"></i>TEL: <a href="tel:0952-71-9855" className="hover:text-white transition-colors cursor-pointer font-semibold">0952-71-9855</a><br />
                    <i className="ri-mail-line mr-2"></i>メール: <a href="mailto:saga@ids-group.jp" className="hover:text-white transition-colors cursor-pointer">saga@ids-group.jp</a>
                  </p>
                </div>
                <div>
                  <h4 className="font-bold text-[#76B947] mb-2 text-sm sm:text-base md:text-lg">IDS川副教習所（九三エンジニアリング株式会社）</h4>
                  <p className="text-gray-300 text-xs sm:text-sm md:text-base leading-relaxed">
                    〒840-2212 佐賀県佐賀市川副町小々森146-1<br />
                    <i className="ri-phone-line mr-2"></i>TEL: <a href="tel:0952-97-5291" className="hover:text-white transition-colors cursor-pointer font-semibold">0952-97-5291</a><br />
                    <i className="ri-mail-line mr-2"></i>メール: <a href="mailto:kawasoe@ids-group.jp" className="hover:text-white transition-colors cursor-pointer">kawasoe@ids-group.jp</a>
                  </p>
                </div>
                <div>
                  <h4 className="font-bold text-[#76B947] mb-2 text-sm sm:text-base md:text-lg">IDS鹿児島教習所（株式会社エコナーセリー）</h4>
                  <p className="text-gray-300 text-xs sm:text-sm md:text-base leading-relaxed">
                    〒899-2504 鹿児島県日置市伊集院町古城795<br />
                    <i className="ri-phone-line mr-2"></i>TEL: <a href="tel:099-213-9466" className="hover:text-white transition-colors cursor-pointer font-semibold">099-213-9466</a><br />
                    <i className="ri-mail-line mr-2"></i>メール: <a href="mailto:kagoshima@ids-group.jp" className="hover:text-white transition-colors cursor-pointer">kagoshima@ids-group.jp</a>
                  </p>
                </div>
              </div>
            </div>

            {/* 製品・サービス */}
            <div>
              <h4 className="font-bold text-[#76B947] mb-3 sm:mb-4 md:mb-6 text-sm sm:text-base md:text-lg">製品・サービス</h4>
              <ul className="space-y-1 sm:space-y-2 md:space-y-3 text-xs sm:text-sm md:text-base">
                <li><button onClick={() => handleNavigation('/drones')} className="text-gray-300 hover:text-white transition-colors cursor-pointer">農業ドローン</button></li>
                <li><button onClick={() => handleNavigation('/auto-steering')} className="text-gray-300 hover:text-white transition-colors cursor-pointer">自動操舵システム</button></li>
                <li><button onClick={() => handleNavigation('/water-management')} className="text-gray-300 hover:text-white transition-colors cursor-pointer">水管理システム</button></li>
                <li><button onClick={() => handleNavigation('/school')} className="text-gray-300 hover:text-white transition-colors cursor-pointer">ドローンスクール</button></li>
                <li><button onClick={() => handleNavigation('/maintenance-service')} className="text-gray-300 hover:text-white transition-colors cursor-pointer">点検・整備サービス</button></li>
                <li><button onClick={() => handleNavigation('/')} className="text-gray-300 hover:text-white transition-colors cursor-pointer">請負散布サービス（準備中）</button></li>
              </ul>
            </div>

            {/* グループ情報 */}
            <div>
              <h4 className="font-bold text-[#76B947] mb-3 sm:mb-4 md:mb-6 text-sm sm:text-base md:text-lg">グループ情報</h4>
              <ul className="space-y-1 sm:space-y-2 md:space-y-3 text-xs sm:text-sm md:text-base">
                <li>
                  <Link 
                    to="/" 
                    className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                  >
                    導入事例（準備中）
                  </Link>
                </li>
                <li>
                  <button 
                    className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                    onClick={() => window.REACT_APP_NAVIGATE('/about')}
                  >
                    グループ概要
                  </button>
                </li>
                <li>
                  <button 
                    className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                    onClick={() => window.REACT_APP_NAVIGATE('/locations')}
                  >
                    拠点一覧（お問い合わせ）
                  </button>
                </li>
                <li>
                  <button 
                    className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                    onClick={() => window.REACT_APP_NAVIGATE('/privacy-policy')}
                  >
                    プライバシーポリシー
                  </button>
                </li>
              </ul>
            </div>

          </div>
        </div>

        <div className="border-t border-gray-600">
          <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 py-3 sm:py-4 md:py-6">
            <div className="flex flex-col md:flex-row justify-between items-center text-xs sm:text-sm md:text-base text-gray-300 space-y-2 md:space-y-0">
              <div>© 2024 IDS教習所グループ All Rights Reserved.</div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
